import { FIREBASE_IMAGE } from "../config/constant";

export default class Post {
  constructor(data = {}, id) {
    this.id = id;
    this.uid = data.uid;
    this.image = data.image;
    this.cntLike = data.cntLike ?? 0;
    this.cntBlocked = data.cntBlocked ?? 0;
    this.cntComment = data.cntComment ?? 0;
    this.description = data.description;
    this.tags = data.tags;
    this.items = data.items ?? [];
    this.approve = data.approve;
    this.draft = data.draft ?? false;
    this.imageID = data.imageID; // aws ai api id
    //url, name, brand, category, color, x, y,
    this.timestamp = data.timestamp;
    this.fashionCategory = data.fashionCategory;
    this.genderCategory = data.genderCategory;
  }

  // image_url() {
  //   return FIREBASE_IMAGE(`posts%2F${this.id}`, this.image);
  // }

  static postUrl(key, post) {
    return FIREBASE_IMAGE(`posts%2F${key}`, post);
  }
}
